/**
 * Global date formatter for Rektra.
 * Standard format: DD.MM.YYYY (e.g., 25.03.2026) — one format across the
 * whole Icelandic UI.
 */

/**
 * Formats a date string or Date object to DD.MM.YYYY.
 * Accepts: "2026-03-25", "2026-03-25T12:00:00Z", Date object, etc.
 * Returns the original string if parsing fails.
 */
export const formatDate = (input) => {
  if (!input) return '';
  
  let d;
  if (input instanceof Date) {
    d = input;
  } else if (typeof input === 'string') {
    // Handle YYYY-MM-DD or ISO strings
    if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) return input; // Already DD.MM.YYYY
    if (/^(\d{2})-(\d{2})-(\d{4})$/.test(input)) return input.replace(/-/g, '.');
    d = new Date(input);
  } else {
    return String(input);
  }

  if (isNaN(d.getTime())) return String(input);

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}.${month}.${year}`;
};

/**
 * Formats a date string for display with day name (short).
 * Example: "mán 25.03.2026"
 */
export const formatDateWithDay = (input, dayNames) => {
  if (!input) return '';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return formatDate(input);
  const dayIndex = d.getDay();
  const dayName = dayNames?.[dayIndex] || '';
  return `${dayName} ${formatDate(d)}`;
};
